import { ObjetivoService } from '../../services/objetivo.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { ChangeDetectorRef, Component,OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormArray, FormControl, } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject, forkJoin, map } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { AtribucionService } from '../../services/atribucion.service';
import { AtribucionObjetivoService } from '../../services/atribucion-objetivo.service';
import { EspecialUnoService } from 'src/app/modulos/catalogos-proces/services/especial-uno.service';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { EstrategiaObjetivoService } from '../../services/estrategia-objetivo.service';
import { EstrategiasService } from '../../services/estrategias.service';
import { ConstantsCatalogosIdService } from '../../../../services/constants-catalogos-id.service';
import { PlanInstitucionalService } from './../../../catalogos-admin/services/plan-institucional.service';
import { PlanAniosService } from './../../../catalogos-admin/services/plan-anios.service';
import { AniosObjetivosService } from './../../../catalogos-admin/services/anios-objetivos.service';
import { DatePipe } from '@angular/common';
import { RiesgosService } from '../../services/riesgos.service';
import { IndicadoresService } from '../../services/indicadores.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { AniosService } from 'src/app/modulos/catalogos-admin/services/anios.service';

@Component({
  selector: 'app-objetivos',
  templateUrl: './objetivos.component.html',
  styleUrls: ['./objetivos.component.css'],
})
export class ObjetivosComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Formulación Planes' },
    { label: 'Elementos' },
    { label: 'Objetivos', active: true },
  ];
  public formObjetivo!: UntypedFormGroup;
  public formSelectAnio!: UntypedFormGroup;
  //public formSubmitted = false;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameModal: string = 'modalNewEdit';
  public nameModalGestion: string = 'modalNewEdit2';
  nameAppModal = 'OBJETIVOS';
  public nombreUnidad: any = [];
  public estadoActivo: number = 1; //traer los que estan en estado activo 
  public anioObjetivo: string;
  public idSprPlanAnio: number = 0;
  public dataObjetivo: any = []; // trae data de objetivos del Ambiente
  public dataCatEspecialEnfoque!: any; // trae data catalogo Especial Uno Enfoque
  public dataCatEspecialPerspectiva!: any; // trae data catalogo  Especial Uno perspectiva
  public dataAtribucion!: any; //data para Atribucion
  public listadoAtribuciones!: any;
  public dataAtribucionesChecked: any = []; //data para Atribuci
  public idSprObjetivoInput: number = 0
  public dataAniosForMaping: any = []; //data para Atribuci
  public dataAtribucionesProcess: any = []; //data para Atribucion
  public dataAtribucionMap!: any;
  public dataAtribucionObjetivo: any = []; //data relacionada de Objetivo-Atribucion
  public dataEstrategiasObjetivos: any = []; //
  public dataEstrategias: any = []; //
  public idSprAmbiente!: number;
  public idRecursivoEnfoque: number = 0;
  public idRecursivoPerspectiva: number = 0;
  public idSprNivelN1: number = 0; //validacion (de nivel n1)
  public idSprNivelN5: number = 0; //validacion (de nivel n5)
  public nivelSelect!: number;
  public dataAtribucionObjMapeada: any = [];
  public dataAmbiente!: any;
  public dataObjetivoMain!: any;
  public atribucionesMap: any = [];
  public dataAniosNew!: any;
  public dataEstrategiaObjetivoMain: any = [];
  public dataPlanInstitucional: any = [];
  public dataPlanesAnios: any = [];
  public idSprAnio: number = 0;
  public idSprNivel: number = 0;
  public dataPlanesAniosParaModal: any = [];
  public dataAniosObj: any = [];
  public dataAnios: any = [];
  public dataPlanesInsPlanesAnios: any = [];
  public d: any = [];
  public mostrarModalAlineacion: boolean = false;
  public cerrado: boolean = false;
  public candado: boolean = false;
  public objetivo: any = 0;
  public idObjetivoSeleccionado: number = 0;
  public idSprPlanInsAnio: number = 0;
  public objetivoNombre: string = '';
  public idSprSelectAnio: number = 0;
  public estrategiaObjetivo: any = [];
  public idSprTargetAnio: number = 0;
  public anioSeleccionadoForm: any;
  public anioSelec: any = new Date().getFullYear(); // validacion para inico de cada plan año
  public fechaInicioN: any;
  public fechaFinN: any;
  public valor: number;
  //public candado: bool = false;
  public planAniosSelect: any = null; // validador de fechas del plan redux
  anioActual: string = '';
  hoy = new Date();

  finIngreso: string;
  pipe = new DatePipe('en-US');
  private anioFecha: PlanAniosService;
  public datosfecha: any[] = [];
  public anioNuevo: number;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @ViewChild('modalChild') myModal: any;

  //Almacena el usuario actual disponible en Redux
  currentUserRedux: UsuarioRedux = null;
  public selectedItems: any
  public opciones: any[] = []

  idSprPlanInstitucionalRedux: any;
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private objetivosService: ObjetivoService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    public atribucionService: AtribucionService,
    public atribucionObjetivoService: AtribucionObjetivoService,
    public catalogoEspecialUnoService: EspecialUnoService,
    private ambienteService: AmbienteService,
    private estrategiasObjetivosService: EstrategiaObjetivoService,
    private estrategiasService: EstrategiasService,
    private aniosService: PlanAniosService,
    private aniosServiceNew: AniosService,
    private planAniosService: AniosObjetivosService,
    private riesgosService: RiesgosService,
    private indicadoresService: IndicadoresService,
    private planesInstService: PlanInstitucionalService,
    private cd: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    //this.anioActual = this.pipe.transform(this.hoy, 'YYYY');

    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentUser.nombreUnidad;
    //this.anioObjetivo = this.anioActual;
    //this.idSprAmbiente = this.currentUser.idSprAmbiente;

    //######## IDS DE CATALOGOS #################
    this.idRecursivoEnfoque = ConstantsCatalogosIdService.ID_ESPECIAL1_ENFOQUE;
    this.idRecursivoPerspectiva =
      ConstantsCatalogosIdService.ID_ESPECIAL1_PERSPECTIVA;
    this.idSprNivelN1 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_1;
    this.idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;

    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  ngOnInit(): void {
    this.selectedItems = new Array<string>();
    this.store.select('globalApp').subscribe((response) => {

      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.planAniosSelect = response.planAniosSeleccionado;
      this.idSprPlanInstitucionalRedux = response.planAniosSeleccionado.idSprAnio;
      this.nivelSelect = response.ambienteSeleccionado.nivel.idSprNivel;
      //this.getDataAniosObj(this.idSprPlanInstitucionalRedux); //verificar
      if (this.idSprPlanAnio > 0) {
        this.initApp();
      }
    });
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
    });
    //this.nivelSelect = this.currentUser.idSprNivel;

  }

  initApp() {
    this.getDataAll();
    this.listCatEnfoque();
    this.listCatPerspectiva();
    this.setDataTable();
    this.setForm();
    //this.getDataAnios();
    this.setSelectAnioForm();
    // this.nivelSeleccionado();
    this.listAmbiente(this.idSprAmbiente);
    this.getIpPublic();
    this.nivelSeleccionado();
    this.listAtribuciones();
  }

  getDataAll() {
    forkJoin([
      this.atribucionService.list('?idSprAmbiente=' + this.idSprAmbiente),
      this.atribucionObjetivoService.list(),
      this.estrategiasObjetivosService.list(),
      this.estrategiasService.list(),
      this.objetivosService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + this.idSprPlanAnio),
      this.aniosService.list(),
      this.planesInstService.list(),
      this.planAniosService.list(),
      this.aniosServiceNew.list(),
    ]).pipe(
      map(([dataAtribucion, dataAtribucionObjetivo, dataEstrategiasObjetivos, dataEstrategias, objetivos, anios, planesInst, planesAnios,
        aniosNew,]) => {
        this.dataAtribucion = dataAtribucion;
        this.dataAtribucionObjetivo = dataAtribucionObjetivo;
        this.dataEstrategiasObjetivos = dataEstrategiasObjetivos;
        this.dataEstrategias = dataEstrategias;
        this.dataObjetivo = objetivos;
        this.dataAniosForMaping = anios;
        this.dataPlanInstitucional = planesInst;
        this.dataPlanesAnios = planesAnios;
        this.dataAniosNew = aniosNew;
        //this.mapearDataAniosPlanes();
        //this.setDataAtribucionesChecked();
        this.mapeoAtribucionObjetivo();
        this.setDataPlanesAnios();
        this.reDrawDataTable();
      }
      )
    ).subscribe();
  }

  //mapeo atribucion objetivo
  mapeoAtribucionObjetivo() {
    let dataProcess: any = [];
    let atribucionObjetivo: any = [];
    let estrategiaObjetivo: any = [];
    let idSprPlanAnio: number = 0;
    let idSprAnio: number = 0;
    let nameAnio: number = 0;
    //Revisar
    for (let ac = 0; ac < this.dataPlanesAnios.length; ac++) {
      for (let i = 0; i < this.dataObjetivo.length; i++) {
        if (this.dataObjetivo[i].idSprPlanAnio == this.dataPlanesAnios[ac].idSprPlanAnio) {
          // Atribuciones-objetivos
          for (let j = 0; j < this.dataAtribucionObjetivo.length; j++) {
            if (this.dataObjetivo[i].idSprObjetivo == this.dataAtribucionObjetivo[j].idSprObjetivo) {
              for (let k = 0; k < this.dataAtribucion.length; k++) {
                if (this.dataAtribucion[k].idSprAtribucion == this.dataAtribucionObjetivo[j].idSprAtribucion) {
                  atribucionObjetivo.push({
                    idSprAtribucion: this.dataAtribucion[k].idSprAtribucion,
                    nombre: this.dataAtribucion[k].nombre,
                  });
                }
              }
            }
          }

          // Anio-Objetivo
          for (let z = 0; z < this.dataPlanesAnios.length; z++) {
            if (
              this.dataObjetivo[i].idSprPlanAnio ==
              this.dataPlanesAnios[z].idSprPlanAnio
            ) {
              for (let ab = 0; ab < this.dataAniosForMaping.length; ab++) {
                if (
                  this.dataPlanesAnios[z].idSprAnio ==
                  this.dataAniosForMaping[ab].idSprAnio
                ) {
                  idSprPlanAnio = this.dataPlanesAnios[z].idSprPlanAnio;
                  nameAnio = this.dataAniosForMaping[ab].anio;
                  idSprAnio = this.dataAniosForMaping[ab].idSprAnio;
                }
              }
            }
          }
          // Estrategias-objetivos
          for (let m = 0; m < this.dataEstrategiasObjetivos.length; m++) {
            if (
              this.dataObjetivo[i].idSprObjetivo ==
              this.dataEstrategiasObjetivos[m].idSprObjetivo
            ) {
              for (let n = 0; n < this.dataEstrategias.length; n++) {
                if (
                  this.dataEstrategias[n].idSprEstrategia ==
                  this.dataEstrategiasObjetivos[m].idSprEstrategia &&
                  this.dataEstrategiasObjetivos[m].nivelSuperior == 'N'
                ) {
                  estrategiaObjetivo.push({
                    idSprEstrategia: this.dataEstrategias[n].idSprEstrategia,
                    nombre: this.dataEstrategias[n].nombre,
                  });
                }
              }
            }
          }
          dataProcess.push({
            idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
            idSprAmbiente: this.dataObjetivo[i].idSprAmbiente,
            descripcion: this.dataObjetivo[i].descripcion,
            idSprEnfoque: this.dataObjetivo[i].idSprEnfoque,
            idSprPerspectiva: this.dataObjetivo[i].idSprPerspectiva,
            fechaInicio: this.dataObjetivo[i].fechaInicio,
            fechaFin: this.dataObjetivo[i].fechaFin,
            nombre: this.dataObjetivo[i].nombre,
            estado: this.dataObjetivo[i].estado,
            atribuciones: atribucionObjetivo,
            estrategias: estrategiaObjetivo,
            idSprPlanAnio: idSprPlanAnio,
            idSprAnio: idSprAnio,
            nameAnio: nameAnio,
            nroEstrategias:
              estrategiaObjetivo.length > 0 ? estrategiaObjetivo.length : 0,
            nroAtribuciones:
              atribucionObjetivo.length > 0 ? atribucionObjetivo.length : 0,
          });
          atribucionObjetivo = [];
          estrategiaObjetivo = [];
          idSprPlanAnio = 0;
          idSprAnio = 0;
        } else {
        }
      }
    }
    this.dataAtribucionObjMapeada = dataProcess;
  }


  /*Función para el control de estrategias en el Nivel 5 */
  nivelSeleccionado(): number {
    if (this.idSprNivel == this.idSprNivelN5) {
      return (this.valor = 1);
    } else {
      return (this.valor = 2);
    }
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  get objetivoForm() {
    //this.opciones = [];
    return this.formObjetivo.controls;
  }
  //validacion para el boton nuevo que se desabilite
  verificarEstrategias(objetivos: any[]): boolean {
    if (this.idSprNivelN5 === 1) {
      return true;
    }
    return objetivos.some((obj) => obj.nroEstrategias === 0);
  }
  mostrarAlertaEstrategia() {
    // mensaje de alerta
    this.alert.EstrategiasAgregar();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formObjetivo = this.fb.group({
      idSprAtribucionObjetivo: [],
      //idSprAtribucion: new Array<string>(),
      //idSprAtribucion: new FormArray([]),
      idSprAtribucion: new FormArray([]),
      idSprObjetivo: [],
      idSprAmbiente: [],
      idSprPlanAnio: [],
      //idSprAnio: ['', Validators.required],
      // idSprAnioAnterior: [],
      nombre: ['', Validators.required],
      descripcion: [''],
      idSprEnfoque: [''],
      idSprPerspectiva: [''],
      idSprEstrategia: [],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.planAniosSelect?.fechaInicio, this.planAniosSelect?.fechaFin),],],
      fechaFin: ['', [Validators.required, validadorFechaIntervalo(this.planAniosSelect?.fechaInicio, this.planAniosSelect?.fechaFin),],],
      estado: ['', Validators.required],
    });
  }

  setSelectAnioForm() {
    this.formSelectAnio = this.fb.group({
      idSprAnioSelected: [this.idSprSelectAnio],
    });
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  // mapeo de datos planes-años para select de crear editar en modal
  setDataPlanesAnios() {
    let dataProcess: any = [];
    for (let a = 0; a < this.dataAniosNew.length; a++) {
      for (let b = 0; b < this.dataPlanesAnios.length; b++) {
        if (
          this.dataAniosNew[a].idSprAnio == this.dataPlanesAnios[b].idSprAnio
        ) {
          for (let c = 0; c < this.dataPlanInstitucional.length; c++) {
            if (
              this.dataPlanInstitucional[c].idSprPlanInstitucional ==
              this.dataPlanesAnios[b].idSprPlanInstitucional &&
              this.dataPlanesAnios[b].estado == 1 &&
              this.dataPlanesAnios[b].idSprPlanAnio == this.idSprPlanAnio
            ) {
              dataProcess.push({
                nombre: this.dataPlanInstitucional[c].nombre,
                anio: this.dataAniosNew[a].anio,
                idSprPlanAnio: this.dataPlanesAnios[b].idSprPlanAnio,
                idSprAnio: this.dataPlanesAnios[b].idSprAnio,
              });
            }
          }
        }
      }
    }
    this.dataPlanesInsPlanesAnios = dataProcess;
  }

  getEstrategias() {
    this.objetivo = {
      name: 'estratégia',
      idSprObjetivo: this.idObjetivoSeleccionado,
      objetivoNombre: this.objetivoNombre,
    };
  }

  getEstrategiasSuperior() {
    this.objetivo = {
      name: 'estrategia-sup',
      idSprObjetivo: this.idObjetivoSeleccionado,
      objetivoNombre: this.objetivoNombre,
      idSprSelectAnio: this.idSprTargetAnio,
    };
  }


  onSubmit(): boolean {
    let idSprObjetivo = this.formObjetivo.value.idSprObjetivo;
    let idSprUsuario = this.currentUser.idSprUsuario;
    if (this.formObjetivo.value.fechaInicio > this.formObjetivo.value.fechaFin) {
      this.alert.warning(
        '¡Atención!',
        'La fecha inicio no puede ser mayo a la fecha fin'
      );
      return false;
    }
    this.submitted = true;
    this.formObjetivo.value.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.formObjetivo.value.usuario = this.currentUser.idSprUsuario;
    this.formObjetivo.value.nombre.trim();
    this.formObjetivo.value.ip = this.ipAddress;
    this.formObjetivo.value.idSprPlanAnio = this.idSprPlanAnio;


    if (this.formObjetivo.valid) {
      if (this.formObjetivo.value.idSprObjetivo == null || this.formObjetivo.value.idSprObjetivo == '') {
        let arregloAtribuciones = this.formObjetivo.value.idSprAtribucion;

        if (arregloAtribuciones.length === 0) {
          this.alert.atribucionAlerta();
        } else {
          this.objetivosService.create(this.formObjetivo.value).subscribe({
            next: (dataResponseObjetivo) => {
              // for recorre inserciones atribuciones
              for (let elemento of arregloAtribuciones) {
                let dataAtribuciones = {
                  idSprObjetivo: dataResponseObjetivo.idSprObjetivo,
                  idSprAtribucion: elemento.idSprAtribucion,
                  usuario: this.currentUser.idSprUsuario,
                  ip: this.ipAddress,
                  estado: '1',
                };
                // Inserta N atribuciones
                this.atribucionObjetivoService.create(dataAtribuciones).subscribe({
                  next: (data) => {
                  },
                  error: (error) => { },
                });
              }
              this.initApp()
              this.closeModal();
              this.alert.createOk();
              return true;
            },
            error: (err) => {
              this.alert.createError();
            },
          });
        }
      } else {//Actualizar/modificar        
        let verificaAtribucion: boolean = false
        let acumulador: number = 0
        let idsAtribucionesObjetivosActuales;
        this.atribucionObjetivoService.list(`?idSprObjetivo=${this.formObjetivo.value.idSprObjetivo}`).subscribe((data) => {
          idsAtribucionesObjetivosActuales = data;
          let idsAtribucionesDeFormulario = this.formObjetivo.value.idSprAtribucion;
          this.formObjetivo.value.ip = this.ipAddress;
          this.formObjetivo.value.usuario = this.currentUser.idSprUsuario;
          let check: boolean = false;
          let atribucionesFixed = this.dataAtribucionesProcess;

          if (idsAtribucionesDeFormulario.length != 0) {
            for (let x = 0; x < this.dataAtribucionesProcess.length; x++) {
              for (let y = 0; y < idsAtribucionesDeFormulario.length; y++) {
                if ((this.dataAtribucionesProcess[x].idSprAtribucion == idsAtribucionesDeFormulario[y].idSprAtribucion) && idsAtribucionesDeFormulario[y].checked == true) {
                  check = true;
                  atribucionesFixed[x].checked = check;
                } else if ((this.dataAtribucionesProcess[x].idSprAtribucion == idsAtribucionesDeFormulario[y].idSprAtribucion) && idsAtribucionesDeFormulario[y].checked == false) {
                  check = false;
                  atribucionesFixed[x].checked = check;
                }
              }

              //check = false;
            }
            let atribucionesProcesar = atribucionesFixed;
            for (let z = 0; z < atribucionesProcesar.length; z++) {
              if (atribucionesProcesar[z].checked == true) {
                acumulador++;
              }
            }
            if (acumulador > 0) {
              verificaAtribucion = true
            } else {
              this.alert.warning('Atención', 'Debe seleccionar por lo menos una atribución/competencia');
            }
          } else {
            verificaAtribucion = true
          }
          if (verificaAtribucion == true) {
            this.objetivosService.update(this.formObjetivo.value).subscribe({
              next: (data) => {
                for (let i = 0; i < idsAtribucionesDeFormulario.length; i++) {
                  for (let j = 0; j < idsAtribucionesObjetivosActuales.length; j++) {
                    if (idsAtribucionesDeFormulario[i].checked == false &&
                      idsAtribucionesObjetivosActuales[j].idSprAtribucion == idsAtribucionesDeFormulario[i].idSprAtribucion &&
                      idsAtribucionesObjetivosActuales[j].estado == 1) {
                      let dataAtribucionObjetivoActualiza = {
                        idSprAtribucionObjetivo: idsAtribucionesObjetivosActuales[j].idSprAtribucionObjetivo,
                        delLog: 'S',
                        usuario: idSprUsuario,
                        ip: this.ipAddress,
                        estado: 1,
                      };
                      this.atribucionObjetivoService.update(dataAtribucionObjetivoActualiza).subscribe();
                    }
                  }
                  if (idsAtribucionesDeFormulario[i].checked == true) {
                    let dataAtribucionObjetivoCreate = {
                      idSprObjetivo: idSprObjetivo,
                      idSprAtribucion: idsAtribucionesDeFormulario[i].idSprAtribucion,
                      usuario: idSprUsuario,
                      ip: this.ipAddress,
                      estado: 1,
                    };
                    this.atribucionObjetivoService.create(dataAtribucionObjetivoCreate).subscribe();
                  }
                }
                this.closeModal();
                this.initApp();
                this.alert.updateOk();
              },
              error: (err) => { },
            });

          }
          // Actualizacion a la tabla objetivos
          // Fn update obj
        },
          (err) => {
            this.alert.createError();
          }
        );
      }
      return false;
    } else {
      return false;
    }
  }

  edit(obj: any) {
    this.openModalEditar();
    this.estrategiasObjetivosService.list('?idSprObjetivo=' + obj.idSprObjetivo).subscribe((res) => {
      this.estrategiaObjetivo = res;
    });
    this.dataAtribucionesChecked = obj.atribuciones;
    this.idSprObjetivoInput = obj.idSprObjetivo
    this.setDataAtribucionesCheck();

    this.formObjetivo.patchValue({
      idSprObjetivo: obj.idSprObjetivo,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      idSprEnfoque: obj.idSprEnfoque,
      idSprPlanAnio: obj.idSprPlanAnio,
      idSprPerspectiva: obj.idSprPerspectiva,
      idSprAtribucion: obj.atribuciones,
      idSprEstrategia: obj.estrategias,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      estado: obj.estado,
    });

    //CODIGO PARA RESTABLECER EL SCROLL DE UN MODAL
    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);
  }

  gestionObjetivosEstrategias(row: any) {
    this.idObjetivoSeleccionado = row.idSprObjetivo;
    this.objetivoNombre = row.nombre;
    this.openModalEstrategias();
  }

  delete(row: any) {
    this.idDeleteRegister = row.idSprObjetivo;
    this.idSprPlanInsAnio = row.idSprPlanInsAnio;
    this.modal.open('del');
  }

  confirmDelete(objetivos: any[]) {
    if (this.idDeleteRegister > 0) {
      this.estrategiasObjetivosService
        .list(`?idSprObjetivo=${this.idDeleteRegister}&delLog=N`)
        .subscribe((response) => {
          if (response.length < 1) {
            this.riesgosService
              .list(`?idSprObjetivo=${this.idDeleteRegister}&delLog=N`)
              .subscribe((response) => {
                if (response.length < 1) {
                  this.indicadoresService
                    .list(`?idSprObjetivo=${this.idDeleteRegister}&delLog=N`)
                    .subscribe((response) => {
                      if (response.length < 1) {
                        /********************** */
                        if (this.idDeleteRegister > 0) {
                          let objetivo = {
                            idSprObjetivo: this.idDeleteRegister,
                            ip: this.ipAddress,
                            usuario: this.currentUser.idSprUsuario,
                            delLog: 'S',
                          };
                          this.objetivosService.update(objetivo).subscribe({
                            next: (data) => {
                              let anioObjetivo = {
                                idSprPlanInsAnio: this.idSprPlanInsAnio,
                                ip: this.ipAddress,
                                usuario: this.currentUser.idSprUsuario,
                                delLog: 'S',
                              };
                              this.planAniosService
                                .update(anioObjetivo)
                                .subscribe({
                                  next: (data) => {
                                    for (
                                      let i = 0;
                                      i < this.dataAtribucionObjetivo.length;
                                      i++
                                    ) {
                                      if (
                                        objetivo.idSprObjetivo ==
                                        this.dataAtribucionObjetivo[i]
                                          .idSprObjetivo
                                      ) {
                                        let atribucionObjetivo = {
                                          idSprAtribucionObjetivo:
                                            this.dataAtribucionObjetivo[i]
                                              .idSprAtribucionObjetivo,
                                          ip: this.ipAddress,
                                          delLog: 'S',
                                        };
                                        this.atribucionObjetivoService
                                          .update(atribucionObjetivo)
                                          .subscribe((data) => {
                                            this.dataAtribucionObjMapeada =
                                              objetivos.filter(
                                                (item) =>
                                                  item.idSprObjetivo !==
                                                  this.idDeleteRegister
                                              );
                                          });
                                      }
                                    } // Fin for
                                  },
                                  error: (err) => { },
                                });
                              //this.initApp();

                              this.modal.close();
                              //this.formObjetivo.value.nombre = "";
                              this.alert.deleteOk();
                              this.initApp();
                            },
                            error: (err) => {
                              this.alert.createError();
                              this.modal.close();
                            },
                          });
                        }
                        /********************** */
                      } else {
                        this.alert.warning(
                          'Atención',
                          'No se puede borrar este registro, EXISTE INDICADORES RELACIONADOS!'
                        );
                        this.modal.close();
                      }
                    });
                } else {
                  this.alert.warning(
                    'Atención',
                    'No se puede borrar este registro, EXISTE RIESGOS RELACIONADOS!'
                  );
                  this.modal.close();
                }
              });
          } else {
            this.alert.warning(
              'Atención',
              "No se puede borrar este registro, existe 'ESTRATEGIAS' relacionadas!"
            );
            this.modal.close();
          }
        });
    } else {
      this.alert.warning(
        'Atención',
        'Ocurrió un error al intentar borrar el registro'
      );
      this.modal.close();
    }
  }

  listCatEnfoque() {
    this.catalogoEspecialUnoService
      .list(`?spr_idSprEspecialUno=${this.idRecursivoEnfoque}`)
      .subscribe((resp) => {
        this.dataCatEspecialEnfoque = resp;
      });
    return true;
  }

  listCatPerspectiva() {
    this.catalogoEspecialUnoService
      .list(`?spr_idSprEspecialUno=${this.idRecursivoPerspectiva}`)
      .subscribe((resp) => {
        this.dataCatEspecialPerspectiva = resp;
      });
    return true;
  }


  onChange(event: any, id: any) {
    let indice = -1;
    for (let i = 0; i < this.opciones.length; i++) {
      if (this.opciones[i].idSprAtribucion === id) {
        indice = i;
        break; // Si encuentra sal del bucle
      }
    }
    if (indice === -1) {
      this.opciones.push({
        idSprAtribucion: id,
        checked: event.target.checked,
      });
    } else {
      this.opciones.splice(indice, 1);
    }
    this.formObjetivo.value.idSprAtribucion = this.opciones;
  }


  listAtribuciones() {
    this.atribucionService.list('?idSprAmbiente=' + this.idSprAmbiente + '&estado=' + this.estadoActivo).subscribe(resp => {
      this.listadoAtribuciones = resp
    })
  }

  setDataAtribucionesCheck() {
    let atribucionesFixed = this.listadoAtribuciones;
    for (let k = 0; k < this.dataAtribucionObjMapeada.length; k++) {
      if (this.dataAtribucionObjMapeada[k].idSprObjetivo === this.idSprObjetivoInput) {
        this.atribucionesMap = this.dataAtribucionObjMapeada[k].atribuciones;
      }
    }
    let checked: boolean = false;
    for (let i = 0; i < this.listadoAtribuciones.length; i++) {
      for (let j = 0; j < this.atribucionesMap.length; j++) {
        if (this.listadoAtribuciones[i].idSprAtribucion === this.atribucionesMap[j].idSprAtribucion) {
          checked = true;
        }
      }
      atribucionesFixed[i].checked = checked;
      checked = false;
    }
    this.dataAtribucionesProcess = atribucionesFixed;
  }

  /*****INICIO METODOS PARA ESTRATEGIAS-OBJETIVOS ******/

  listAmbiente(idSprAmbiente: number) {
    this.ambienteService.list(`${idSprAmbiente}`).subscribe((resp) => {
      this.dataAmbiente = resp;
      this.listObjetivoMain();
    });
  }

  listObjetivoMain() {
    // trae los datos  de objetivos y del nivel superior
    this.objetivosService.list('?idSprAmbiente=' + this.dataAmbiente.spr_idSprAmbiente).subscribe((resp) => {
      this.dataObjetivoMain = resp;
    });
  }

  listEstrategiaObjetivoMain() {
    // consulta para el nivel superior
    for (let elemento of this.dataObjetivoMain) {
      this.estrategiasObjetivosService.list('?idSprObjetivo=' + elemento.idSprObjetivo).subscribe((resp) => {
        this.dataEstrategiaObjetivoMain = resp;
        let estrategiasobj1 = this.listEstrategiaNombre();
        elemento.estrategias = estrategiasobj1;
      });
    }
    return this.dataObjetivoMain;
  }

  listEstrategiaNombre() {
    //nivel superir
    let estrategiasobj1 = [{}];
    let x = 0;
    for (let elemento of this.dataEstrategiaObjetivoMain) {
      this.estrategiasService.list(`${elemento.idSprEstrategia}` )
        .subscribe((resp) => {
          estrategiasobj1[x] = {
            idSprEstrategia: resp.idSprEstrategia,
            nombre: resp.nombre,
          };
          x = x + 1;
        });
    }
    x = 0;
    return estrategiasobj1;
  }

  mostrarAlineacionEstrategia(obj: any) {
    this.listEstrategiaObjetivoMain();
    this.mostrarModalAlineacion = true;
  }

  /*****FIN METODOS PARA ESTRATEGIAS-OBJETIVOS ******/

  openModalNew(form: any) {
    if (this.valor == 2) {
      this.alert.EstrategiaNuevo(); //para que aparesco un mensaje cuando va a crear un elemento
    }
    this.submitted = false;
    this.formObjetivo.reset();
    this.formObjetivo.patchValue({
      ...this.formObjetivo.value,
      idSprAnio: form.value.idSprAnioSelected,
      fechaInicio: this.fechaInicioN,
      fechaFin: this.fechaFinN,
    });
    this.modal.open(this.nameModal);

    //CODIGO PARA RESTABLECER EL SCROLL DE UN MODAL
    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);
  }

  openModalEditar() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  closeModal() {
    this.opciones = []
    this.listadoAtribuciones = []
    this.listAtribuciones()
    this.modal.closeId(this.nameModal);
  }

  openModalEstrategias() {
    this.getEstrategias();
    this.getEstrategiasSuperior();
    this.modal.open(this.nameModalGestion);
  }

  closeModalEstrategias() {
    this.initApp();
    this.modal.closeId(this.nameModalGestion);
  }

  onResetForm() {
    this.submitted = false;
    this.formObjetivo.reset();
  }
}
